import { render } from "./OrderAlerts.vue?vue&type=template&id=5e5e0eb5&scoped=true"
import script from "./OrderAlerts.vue?vue&type=script&lang=js"
export * from "./OrderAlerts.vue?vue&type=script&lang=js"

import "./OrderAlerts.vue?vue&type=style&index=0&id=5e5e0eb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5e0eb5"]])

export default __exports__